<template>
  <div class="range-wrapper">
    <div class="range-slider" v-if="items">

      <div class="range-number-input" v-if="inputs">
        <input
          type="number"
          :min="min_angle"
          :max="max_angle"
          step="1"
          :value="slider_min"
        />
        <input
          type="number"
          :min="min_angle"
          :max="max_angle"
          step="1"
          :value="slider_max"
        />
      </div>

      <div class="range-slider-input" @click.prevent="handle_click">
        <input
          ref="min"
          type="range"
          :min="min_angle"
          :max="max_angle"
          :value="slider_min"
          step="1"
          @input.prevent="(e) => handle_slider_min_input(e, true)"
          @change.prevent="(e) => handle_slider_min_input(e, false)"
        />

        <input
          ref="max"
          type="range"
          :min="min_angle"
          :max="max_angle"
          :value="slider_max"
          step="1"
          @input.prevent="(e) => handle_slider_max_input(e, true)"
          @change.prevent="(e) => handle_slider_max_input(e, false)"
        />
      </div>

      <div class="range-bars" v-if="items.length > 1">
        <div
          class="range-bar-wrapper"
          v-for="(item, index) in items"
          v-bind:key="index"
          :style="{ height: get_height(item) }">
          <div :class="is_bar_selected(index) ? 'range-bar selected' : 'range-bar'" v-b-popover.hover.top="item.count" />
        </div>
      </div>
    </div>

    <div v-if="vb_options.debug">
      <br><br>
      PROPS<br>
      min: {{ vb_options.min }}<br>
      max: {{ vb_options.max }}<br>
      items: {{ items.length }}<br>
      min_angle: {{ vb_options.min_angle }}<br>
      max_angle: {{ vb_options.max_angle }}<br>
      <hr />
      DATA:<br>
      min_angle: {{this.min_angle}}<br>
      max_angle: {{ this.max_angle }}<br>
      slider_min_live: {{ this.slider_min_live }}<br>
      slider_max_live: {{ this.slider_max_live }}<br>
      slider_min: {{ this.slider_min }}<br>
      slider_max: {{ this.slider_max }}<br>
      items: {{ this.items.length }}<br>
    </div>
  </div>
</template>

<script>
import { number, subtract, sum, divide, multiply, floor, ceil, abs, min, max, round, add } from 'mathjs'
export default {
  name: "vb-range-slider",
  props: {
    vb_options: {
      type: Object,
      default: () => ({
        min: 0,   // default min pre-selezionato
        max: 100, // default max pre-selezionato
        items: [],
        inputs: true,
        allow_click: true,
        min_angle: 0, // bound inferiore intervallo
        max_angle: 0, // bound superiore intervallo
        debug: false,
        threshold: 0,
      })
    }
  },
  created() {
    this.number = number
  },
  mounted() {
  },
  data() {
    let threshold = 0//20
    let round_items = true
    let items = this.vb_options.items
    let inputs = this.vb_options.inputs
    let min_height = 0
    let delta = 20
    let slider_min = 0
    let slider_max = 0
    if (this.vb_options.min_angle) {
      slider_min = round_items ? subtract(ceil(number(this.vb_options.min_angle)), threshold) : number(this.vb_options.min_angle)
    }
    else {
      slider_min = round_items ? subtract(ceil(number(this.vb_options.min)), threshold) : number(this.vb_options.min)
    }
    if (this.vb_options.max_angle) {
      slider_max = round_items ? sum(floor(number(this.vb_options.max_angle)), threshold) : number(this.vb_options.max_angle)
    }
    else {
      slider_max = round_items ? sum(floor(number(this.vb_options.max)), threshold) : number(this.vb_options.max)
    }
    return {
      min_angle: slider_min,
      max_angle: slider_max,
      slider_min_live: slider_min,
      slider_max_live: slider_max,
      slider_min,
      slider_max,
      items,
      delta,
      min_height,
      inputs,
      round_items,
    }
  },
  methods: {
    is_bar_selected(index) {
      const total_bars = this.items.length
      const range = subtract(this.max_angle, this.min_angle)

      const bar_start = sum(
        this.min_angle,
        multiply(divide(index, total_bars), range)
      )
      const bar_end = sum(
        this.min_angle,
        multiply(divide(add(index, 1), total_bars), range)
      )

      return bar_start <= this.slider_max_live && bar_end >= this.slider_min_live
    },
    get_height(item) {
      const min_height = 10
      const min_count = min(...this.items.map(i => i.count))
      const max_count = max(...this.items.map(i => i.count))
      const normalized = divide(
        subtract(item.count, min_count),
        subtract(max_count, min_count)
      )

      if (normalized == 0) return '0%'

      const percent = sum(
        min_height,
        multiply(normalized, subtract(100, min_height))
      )

      return `${percent}%`
    },    
    handle_slider_min_input(event, dragging = false) {
      const val = number(event.target.value)

      if (val < this.slider_max) {
        this.slider_min_live = val
        this.slider_min = val
      }

      this.$emit('change', {
        min: this.slider_min,
        dragging
      })
    },
    handle_slider_max_input(event, dragging = false) {
      const val = number(event.target.value)
      const el = this.items.filter(i => (i.min >= this.slider_min))[0]
      this.slider_max_live = val
      if (el && val >= el.max) {
        this.slider_max = val
      } else if (el) {
        event.target.value = el.max
      } else {
        this.slider_max = val
      }
      this.$emit('change', {
        max: this.slider_max,
        dragging
      })
    },
    handle_click(event) {
      if (this.vb_options.allow_click == false) return
      event.preventDefault()
      if (event.target.tagName == 'input') return
      if (event.target.type === 'range') return
      const input = event.target;
      const rect = input.getBoundingClientRect();
      const click_x = subtract(event.clientX, rect.left);
      const percent = divide(click_x, rect.width);
      const new_value = round(
        sum(
          this.min_angle,
          multiply(percent, subtract(this.max_angle, this.min_angle))
        )
      );
      if (new_value < this.slider_min) {
        this.slider_min = new_value
        this.slider_min_live = new_value
        this.$emit('change', {
          min: this.slider_min,
          dragging: false
        })
        return
      }
      if (new_value > this.slider_max) {
        this.slider_max = new_value
        this.slider_max_live = new_value
        this.$emit('change', {
          max: this.slider_max,
          dragging: false
        })
        return
      }
      const slider_min_delta = abs(subtract(this.slider_min,new_value))
      const slider_max_delta = abs(subtract(this.slider_max,new_value))
      if (slider_min_delta < slider_max_delta) {
        this.slider_min = new_value
        this.slider_min_live = new_value
        this.$emit('change', {
          min: this.slider_min,
          dragging: false
        })
        return
      }

      this.slider_max = new_value
      this.slider_max_live = new_value
      this.$emit('change', {
        max: this.slider_max,
        dragging: false
      })
    },
  }
}
</script>

<style lang="scss">
.range {
  &-slider {
    width: 300px;
    margin: auto;
    text-align: center;
    position: relative;
    min-height: 60px;
    //height: 6em;

    input[type=range] {
      position: absolute;
      left: 0;
      bottom: 0;
      pointer-events: none; /* disabilita tutto */
      &::-webkit-slider-thumb {
        pointer-events: auto; /* abilita solo il drag */
      }      
    }

    input[type=number] {
      border: 1px solid #ddd;
      text-align: center;
      -moz-appearance: textfield;
    }

    input[type=number]::-webkit-outer-spin-button,
    input[type=number]::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }

    input[type=number]:invalid,
    input[type=number]:out-of-range {
      border: 2px solid var(--secondary);
    }

    input[type=range] {
      -webkit-appearance: none;
      width: 100%;
    }

    input[type=range]:focus {
      outline: none;
    }

    input[type=range]:focus::-webkit-slider-runnable-track {
      background: var(--info);
    }

    input[type=range]:focus::-ms-fill-lower {
      background: var(--info);
    }

    input[type=range]:focus::-ms-fill-upper {
      background: var(--info);
    }

    input[type=range]::-webkit-slider-runnable-track {
      width: 100%;
      height: 3px;
      cursor: pointer;
      animate: 0.2s;
      background: var(--info);
      border-radius: 1px;
      box-shadow: none;
      border: 0;
    }

    input[type=range]::-webkit-slider-thumb {
      z-index: 2;
      position: relative;
      box-shadow: 0px 0px 0px #000;
      //border: 1px solid var(--info);
      height: 15px;
      width: 15px;
      border-radius: 25px;
      background: var(--info);
      cursor: pointer;
      -webkit-appearance: none;
      margin-top: -6px;
    }

  }

  &-number-input {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1rem;
  }

  &-slider-input {
    //background-color: red;
    height: 100%;
    width: 100%;
    position: absolute;
    bottom: 0;
  }

  &-wrapper {
    position: relative;
  }

  &-bars {
    height: 80px;
    display: flex;
    align-items: flex-end;
    padding-left: 6px;
    padding-right: 6px;
  }

  &-bar-wrapper {
    flex: 1;
    margin: 0 1px 0 0;
    background-color: #ddd;
    margin-bottom: 3px;
  }

  &-bar {
    height: 100%;
    width: 100%;
    &.selected {
      background-color: #bbb;
    }
  }
}
</style>